import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";

// Middlewares (keep normal imports, they’re small and reused)
import SupplierRouteMiddleware from "./middleware/auth/supplierMasterValidRoute";
import UnitRouteMiddleware from "./middleware/auth/unitValidRoute";
import palletMiddleware from "./middleware/auth/PalletMiddleware";
import PartyMiddleware from "./middleware/auth/PartyMiddleware";
import ItemNameMiddleware from "./middleware/auth/ItemNameMiddleware";
import ItemCodeMiddleware from "./middleware/auth/ItemCodeMiddleware";
import GradeMiddleware from "./middleware/auth/GradeMiddleware";

// ✅ Lazy imports for Master modules
const AddSupplier = lazy(() => import("app/pages/Master/SupplierMaster/AddSupplier"));
const ListSupplier = lazy(() => import("app/pages/Master/SupplierMaster/ListSupplier"));
const AddUnit = lazy(() => import("app/pages/Master/UnitMaster/AddUnit"));
const ListUnit = lazy(() => import("app/pages/Master/UnitMaster/ListUnit"));
const AddPallet = lazy(() => import("app/pages/Master/PalletMaster/AddPallet"));
const ListPallet = lazy(() => import("app/pages/Master/PalletMaster/ListPallet"));
const AddGrade = lazy(() => import("app/pages/Master/GradeMaster/AddGrade"));
const ListGrade = lazy(() => import("app/pages/Master/GradeMaster/ListGrade"));
const AddParty = lazy(() => import("app/pages/Master/PartyMaster/AddParty"));
const ListParty = lazy(() => import("app/pages/Master/PartyMaster/ListParty"));
const AddItemName = lazy(() => import("app/pages/Master/ItemNameMaster/AddItemName"));
const ListItemName = lazy(() => import("app/pages/Master/ItemNameMaster/ListItemName"));
const AddItemCode = lazy(() => import("app/pages/Master/ItemCodeMaster/AddItemCode"));
const ListItemCode = lazy(() => import("app/pages/Master/ItemCodeMaster/ListItemCode"));

export const masterRoutes = [
  {
    middleware: [{ element: SupplierRouteMiddleware, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/master/supplier",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListSupplier} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/supplier/add",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddSupplier} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/supplier/edit",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddSupplier} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },

  {
    middleware: [{ element: palletMiddleware, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/master/pallet",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListPallet} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/pallet/add",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddPallet} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/pallet/edit",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddPallet} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },

  {
    middleware: [{ element: UnitRouteMiddleware, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/master/unit",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListUnit} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/unit/add",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddUnit} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/unit/edit",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddUnit} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },

  {
    middleware: [{ element: GradeMiddleware, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/master/grade",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListGrade} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/grade/add",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddGrade} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/grade/edit",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddGrade} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },

  {
    middleware: [{ element: PartyMiddleware, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/master/party",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListParty} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/party/add",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddParty} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/party/edit",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddParty} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },

  {
    middleware: [{ element: ItemNameMiddleware, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/master/item-name",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListItemName} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/item-name/add",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddItemName} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/item-name/edit",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddItemName} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },

  {
    middleware: [{ element: ItemCodeMiddleware, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/master/item-code",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListItemCode} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/item-code/add",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddItemCode} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/master/item-code/edit",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddItemCode} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
];
